//***** require / imports scss / css *******************************//
require('./login.scss');

//***** require / imports js *******************************//
require('./../../../node_modules/holderjs/holder.js');
import ngClassified from 'ng-classified';
// import exampleObject from 'Objects/exampleObject/exampleObject.mdl.js';

//***** Modul start *******************************//
angular.module('login', [
	// ''
])
.constant('$classify', true);



// WEBPACK FOOTER //
// ./src/pages/login/login.mdl.js